import { API_BASE_URL } from "../api/client";
import { EmailInfo } from "../api/hooks";

export function buildEmailDownloadUrl(account: string, date: string, email: EmailInfo): string {
  const accountParam = encodeURIComponent(account);
  const folderParam = encodeURIComponent(email.folder);
  const fileParam = encodeURIComponent(email.filename);
  return `${API_BASE_URL}/v1/accounts/${accountParam}/emails/${date}/${folderParam}/${fileParam}`;
}

export function buildArchiveDownloadUrl(account: string, date: string): string {
  const accountParam = encodeURIComponent(account);
  return `${API_BASE_URL}/v1/accounts/${accountParam}/archive/${date}`;
}

export function buildDigestDownloadUrl(account: string, date: string): string {
  const accountParam = encodeURIComponent(account);
  return `${API_BASE_URL}/v1/accounts/${accountParam}/digest/${date}`;
}
